export enum UserRoleIds{
    ADMIN = 1,
    REGULAR_USER = 2,
    COORDINATOR = 4,
    FINANCE = 6,
}
